import styled, { css, FlattenSimpleInterpolation } from "styled-components";

const BulletListContainerViews: {
  [key: string]: FlattenSimpleInterpolation;
} = {
  mobile: css`
    margin-bottom: 20px;
    padding: 15px 10px;

    h5 {
      font-weight: 500;
      font-size: 20px;
      margin-bottom: 15px;
    }
    p {
      font-size: 14px;
      line-height: 19px;
    }
  `,
  tablet: css`
    padding: 30px 20px;

    h5 {
      font-weight: 500;
      font-size: 24px;
      margin-bottom: 30px;
    }
    p {
      font-size: 18px;
      line-height: 23px;
    }
  `,
  tabletLandscape: css`
    padding: 30px 20px;

    h5 {
      font-weight: 500;
      font-size: 24px;
      margin-bottom: 30px;
    }
    p {
      font-size: 18px;
      line-height: 23px;
    }
  `,

  browser: css`
    width: 100%;
    padding: 30px 20px;

    h5 {
      font-weight: 500;
      font-size: 24px;
      margin-bottom: 30px;
    }
    p {
      font-size: 18px;
      line-height: 23px;
    }
  `,
};

export const BulletListContainer = styled.div`
  margin-bottom: 40px;
  background-color: #ffffff;
  box-shadow: 0px 0px 8.53px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  #list-item {
    display: flex;
    margin-bottom: 15px;
  }
  #bullet {
    margin-top: 4px;
    margin-right: 15px;
  }

  h5 {
    color: ${({ theme }) => theme.colors.nrmaBlue};
  }
  img {
    height: 12px;
  }
  ${(props: { deviceType: string; isLandscape: boolean }) => {
    switch (props.deviceType) {
      case "mobile":
        return BulletListContainerViews["mobile"];
      case "tablet":
        return props.isLandscape
          ? BulletListContainerViews["tabletLandscape"]
          : BulletListContainerViews["tablet"];

      case "browser":
        return BulletListContainerViews["browser"];
    }
  }}
`;
